import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Container , Grid } from 'semantic-ui-react';
import TopBar from '../components/topBar';
import Footer from '../components/footer';
import PlatFormMenu from './features/platformMenu';
import DeviceDisplay from './features/deviceDisplay';
import WebAppDeviceDisplay from './features/webAppDeviceDisplay';
import MobileFeaturesDisplay from './features/mobileFeaturesDisplay';
import WebAppFeaturesDisplay from './features/webAppFeaturesDisplay';
import DPayFunction from './features/dPayFunction';

const styles = {
	container : { 
		backgroundColor : 'white' , 
		height : 'auto' , 
		margin : 0 
	},
	deviceRow : { 
		minHeight : '100vh' , 
		display : 'flex' , 
		justifyContent : 'center' 
	}
}

class FeaturesPage extends Component {
  componentDidMount() {
    const { mixpanel } = this.props;
    mixpanel.track('Feature Page',{ action : 'browse' });
    window.scrollTo(0,0);
  }
	_renderDeviceDisplay(query){
		const { device , feature } = query;
		return (device === 'mobileDevices') ? 
			<DeviceDisplay featureSelected={feature}/> : 
			<WebAppDeviceDisplay featureSelected={feature}/>
	}
	_renderDeviceFeature(query){
		const { device , feature } = query; 
     return (device === 'mobileDevices') ? 
			 <MobileFeaturesDisplay featureSelected={feature}/> : 
			 <WebAppFeaturesDisplay featureSelected={feature}/>
	}
	_renderDeviceRow(query){
		return (
			<Grid.Row columns='2' style={styles.deviceRow}>
				{(query.device) ? this._renderDeviceDisplay(query) : null}
				{(query.device) ? this._renderDeviceFeature(query) : null}
			</Grid.Row>
		)
	}
	_renderFeaturePage(query){
		const { string } = this.props;
		switch (query.feature){
			case 'dPay':
				return (<DPayFunction/>)
			break;
			default :
				return (
					<Grid stackable style={styles.container}>
						<Grid.Row>
							<Grid.Column>
								<p>{string['noFunction']}</p>
							</Grid.Column>
						</Grid.Row>
					</Grid>
				)
			break;
		}
	}
	_renderDevicePage(query){
		return (
			<Grid stackable style={styles.container}>
				 <PlatFormMenu deviceSelected={query.device}/>
				{this._renderDeviceRow(query)}
			</Grid>
		)
	}
  render() {
    const { location } = this.props;
    const { query } = location;
    return (
      <div>
        <TopBar/>
					{(query.device) ? 
						this._renderDevicePage(query) : 
						this._renderFeaturePage(query)  
					}
        <Footer/>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    string : state.preference.string,
    mixpanel : state.ui.tempData.mixpanel
  }
}

export default connect(mapStateToProps,null)(FeaturesPage)



/** WEBPACK FOOTER **
 ** ./src/containers/featuresPage.js
 **/